import FieldProgress from "../../../generic/progress/progress"
import FieldConfig from "../../../proto/field-config"
import ItemModelV2 from "../../../../model2/item2/item-model"
import Project from "../../../../model2/project/project"
import FieldProgress_ConditionForm from "../../../generic/progress/render/condition"


export default class FieldProjectProgress extends FieldProgress {

    constructor(config:FieldConfig) {
        super(config);

        this.typeLabel  = "Project progress";
        this.label      = _.get(config, 'label', "Project progress")

        this.fieldParams.tableCellOnValueChange = this.tableCellOnValueChange
        this.clearButton = _.get(config, 'clearButton', false);

        this.renderComponents.conditionForm = FieldProgress_ConditionForm
    }

    canEdit(model:Project):boolean {
        return model.acl.canChangeProgress
    }


    tableCellOnValueChange = async (item: ItemModelV2, value: number | null) => {

        item.project.progress = value ? value : null

        item.project.save()
    }
}
